import type { IBlogData } from './getBlogData.types';

export const postsPerPage = 3;

export const getBlogData = ({ blogPosts, router }: IBlogData) => {
  const latestBlogPosts = blogPosts
    .filter((post) => post.slug !== router?.query?.slug)
    .sort(
      (a, b) =>
        new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
    )
    .slice(0, 3);

  const blogPost = blogPosts.find((post) => {
    return post.slug === router?.query?.slug;
  });

  return { blogPost, latestBlogPosts };
};
